import { useContext } from "react";
import { GlobalContext } from "store/globalContext";

export const useCloseAndReset = (forceCloseAndReset, isDirty) => {
  const { openConfirmationWithCallback } = useContext(GlobalContext);

  return () => {
    if (isDirty) {
      openConfirmationWithCallback({
        title: "Are you sure?",
        message: "All changes will be lost. Proceed?",
        callbackFn: () => {
          forceCloseAndReset();
        },
      });
      return;
    }
    forceCloseAndReset();
  };
};
